module.exports = __webpack_public_path__ + "static/media/locate.ae039ed5.svg";